export default __webpack_public_path__ + "static/landing_light-38b106b276e93a0daffaca6013eac560.png";